import type { RecoverableConfiguration, TruckConfiguration } from '#app/store/slices/configurationSlice'
import { hasUnsavedChanges } from '#features/ManCode/hasUnsavedChanges'

const isPending = (configuration: TruckConfiguration | RecoverableConfiguration) =>
  configuration.type === 'recoverable-configuration'
    ? true
    : configuration.creation.loadingStep !== 'done' ||
      (configuration.step.requested as string) !== configuration.step.system ||
      configuration.lastManCodeUpdate?.currentlySaving ||
      configuration.history?.some((x) => x.status === 'pending' || x.status === 'queued')

const isTruckConfiguration = (x: TruckConfiguration | RecoverableConfiguration): x is TruckConfiguration => x.type === 'truck-configuration'

const isError = (configuration: TruckConfiguration | RecoverableConfiguration) =>
  configuration.type === 'recoverable-configuration' ? false : !!(configuration.creation.error || configuration.step.error)

export const configurationStatus = (configuration: TruckConfiguration | RecoverableConfiguration) => {
  if (isError(configuration)) {
    return 'error'
  }
  if (isPending(configuration)) {
    return 'pending'
  }
  if (isTruckConfiguration(configuration) && hasUnsavedChanges(configuration)) {
    return 'unsaved'
  }
  if (configuration.apiConfiguration.mode === 'read-only') {
    return 'read-only'
  }
  return 'saved'
}
